import { type SvgIconProps } from '@common/components/svgs/props';

function IconLogout(
  { size = 24, color = 'scheme-feedback-text-color', ...rest }: Readonly<SvgIconProps>,
) {
  return (
    <svg
      {...rest}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="svg-Logout"
    >
      <path
        d="M8.95984 3H11.0402C11.706 2.99999 12.2656 2.99997 12.7234 3.03738C13.2021 3.0765 13.6571 3.16144 14.089 3.38148C14.7475 3.71704 15.283 4.25247 15.6185 4.91103C15.8386 5.34289 15.9235 5.79785 15.9626 6.27657C16 6.73445 16 7.29397 16 7.95984V8H14C14 7.28343 13.9992 6.80615 13.9693 6.43944C13.9403 6.0844 13.889 5.92194 13.8365 5.81902C13.6927 5.53677 13.4632 5.3073 13.181 5.16349C13.0781 5.11105 12.9156 5.05975 12.5606 5.03074C12.1938 5.00078 11.7166 5 11 5H9C8.28343 5 7.80615 5.00078 7.43944 5.03074C7.0844 5.05975 6.92194 5.11105 6.81901 5.16349C6.53677 5.3073 6.3073 5.53677 6.16349 5.81902C6.11105 5.92194 6.05975 6.0844 6.03074 6.43944C6.00078 6.80615 6 7.28343 6 8V16C6 16.7166 6.00078 17.1939 6.03074 17.5606C6.05975 17.9156 6.11105 18.0781 6.16349 18.181C6.3073 18.4632 6.53677 18.6927 6.81901 18.8365C6.92194 18.889 7.0844 18.9403 7.43944 18.9693C7.80615 18.9992 8.28343 19 9 19H11C11.7166 19 12.1938 18.9992 12.5606 18.9693C12.9156 18.9403 13.0781 18.889 13.181 18.8365C13.4632 18.6927 13.6927 18.4632 13.8365 18.181C13.889 18.0781 13.9403 17.9156 13.9693 17.5606C13.9992 17.1939 14 16.7166 14 16H16V16.0402C16 16.706 16 17.2656 15.9626 17.7234C15.9235 18.2022 15.8386 18.6571 15.6185 19.089C15.283 19.7475 14.7475 20.283 14.089 20.6185C13.6571 20.8386 13.2021 20.9235 12.7234 20.9626C12.2656 21 11.7061 21 11.0402 21H8.95982C8.29397 21 7.73443 21 7.27657 20.9626C6.79785 20.9235 6.34289 20.8386 5.91103 20.6185C5.25247 20.283 4.71703 19.7475 4.38148 19.089C4.16143 18.6571 4.07649 18.2022 4.03738 17.7234C3.99997 17.2656 3.99998 16.706 4 16.0401V7.95987C3.99998 7.29398 3.99997 6.73445 4.03738 6.27657C4.07649 5.79785 4.16143 5.34289 4.38148 4.91104C4.71703 4.25247 5.25247 3.71704 5.91103 3.38148C6.34289 3.16144 6.79785 3.0765 7.27657 3.03738C7.73444 2.99997 8.29398 2.99999 8.95984 3Z"
        fill={`var(--${color})`}
      />
      <path
        d="M16.793 9.20712L18.5858 11H9V13H18.5859L16.793 14.7929L18.2072 16.2071L21.3536 13.0607C21.9394 12.4749 21.9394 11.5251 21.3536 10.9394L18.2072 7.79291L16.793 9.20712Z"
        fill={`var(--${color})`}
      />
    </svg>
  );
}

IconLogout.displayName = 'Logout';

export default IconLogout;
